
import { v4 as uuidv4 } from 'uuid';

/**
 * Standardized anonymous ID key - using consistent naming
 */
const ANONYMOUS_ID_KEY = 'anonymous_user_id';

/**
 * Generates or retrieves an anonymous user ID
 * @returns Promise resolving to an anonymous ID string
 */
export const generateAnonymousId = async (): Promise<string> => {
  // Check for existing ID in localStorage with the standardized key
  const existingId = localStorage.getItem(ANONYMOUS_ID_KEY);
  
  if (existingId) {
    return existingId;
  }
  
  // Create a new ID if none exists
  const newId = uuidv4();
  localStorage.setItem(ANONYMOUS_ID_KEY, newId);
  
  return newId;
};

/**
 * Get anonymous ID synchronously (returns null if not set)
 */
export const getAnonymousIdSync = (): string | null => {
  return localStorage.getItem(ANONYMOUS_ID_KEY);
};

/**
 * Clear the anonymous ID (useful for testing)
 */
export const clearAnonymousId = (): void => {
  localStorage.removeItem(ANONYMOUS_ID_KEY);
};
